if (document.querySelector('.site-header__currency')) {

  window.updateCurrency = () => {
    document.querySelector('.site-header__currency').submit()
  }

}
